import { ReactComponent as PlaneIcon } from 'images/object-plane.svg';
import BaseTransportObject from './BaseTransportObject';

export default class Plane extends BaseTransportObject {
  constructor({ basePlace, vesselName, engineType, engineCount, serialNumber, ...config }) {
    super(config);

    this.icon = PlaneIcon;
    this.iconClass = 'icon_plane';

    Object.assign(this, {
      basePlace,
      vesselName,
      engineType,
      engineCount,
      serialNumber,
    });

    Object.assign(this.propertyTitles, {
      useTerm: 'Срок полезного использования',
      vin: 'Идентификационный номер',
      registrationSign: 'Рег. номер',
      basePlace: 'Место базирования',
      horsepower: 'Мощность двигателей (тяга)',
      engineCount: 'Количество двигателей',
      engineType: 'Тип двигателей',
      vesselName: 'Наименование судна',
      serialNumber: 'Серийный заводской номер',
    });
  }

  static typeTitle = 'Воздушный транспорт';

  getTypeTitle() {
    return Plane.typeTitle;
  }

  getTitle() {
    return this.title || `${this.vesselName || ''} ${this.registrationSign || ''}`;
  }

  getName() {
    return `${this.vesselName || ''} ${this.registrationSign || ''}`;
  }

  getPdfTitle() {
    return `${super.getPdfTitle()} ${this.vesselName || ''}`;
  }

  isPlane() {
    return true;
  }
}
